import React from "react";
import { Link } from "react-router-dom";
import { ReactTyped } from "react-typed";
import HeroImg from "../../assets/hero.jpg";
import routes from "../../constants/routes";
import styles from "./Home.module.scss";
import HomeProducts from "./HomeProducts/HomeProducts";
import HomeUs from "./HomeUs/HomeUs";
import HomeMentorships from "./HomeMentorships/HomeMentorships";

const Home = (props) => {
  return (
    <>
      <div
        className={styles.hero}
        style={{ backgroundImage: `url(${HeroImg})` }}
      >
        <div className={`wrapper ${styles.wrap}`}>
          <h2 className={styles.upperTitle}>
            Motoasesor es confianza, garantía y eficiencia.
          </h2>
          <h1 className={styles.title}>
            <div className={styles.dynamic_text_pc}>
              <span className={styles.title_fixed}>
                ¿Querés{" "}
                <span>
                  resolver una falla o realizar un service profesional
                </span>{" "}
                a tu moto?
              </span>
            </div>
          </h1>

          <p className={`${styles.subtitle}`}>
            Si hacés mecánica de motos, sufrís con los diagnósticos y querés ser
            más rentable,{" "}
            <a
              href="https://api.whatsapp.com/send?phone=541156372706"
              target="_blank"
              rel="noreferrer"
              className="link"
            >
              unite al Grupo de Soporte
            </a>
          </p>
        </div>
      </div>
      <HomeUs />
      <HomeMentorships />
      {/* <HomeProducts /> */}
    </>
  );
};

Home.propTypes = {};

export default Home;
